<template>
    <div class="row-12">
        <div class="col-12">
            <section class="row-12">
                <div class="col-6 col-sm-12">
                    <h3>Lista Twoich znajomych</h3>
                    <p class="p-b-5">Każdy z Twoich znajomych może otrzymać od Ciebie wiadomość jak i Ty od nich.
                        Znajomym możesz
                        również udostępniać swoje prace. Posiadanie znajomych dostarcza dużo ciekawych funkcji, zresztą
                        zaproś i sam spróbuj.</p>
                    <div class="m-t-5" style="position: relative;">
                        <hr class="b-hr">
                        <span class="friendsCounter">Nowe zaproszenia: {{invite.length}}</span>
                    </div>
                    <div v-if="invite.length == 0">
                        <h3 class="w-100 text-a-c m-b-5 m-t-4 text-third-d">Brak nowych zaproszeń</h3>
                    </div>
                    <div v-else class="m-y-4">
                        <div class="card m-t-1" v-for="friend in invite">
                            <div class="card-body display-flex">
                                <div class="center-flex-a" style="height: auto;">
                                    <img class="circle-profile" :src="friend.profile_img" :alt="friend.firstname">
                                </div>
                                <div class="p-l-4" style="width: calc(100% - 175px); align-self: center">
                                    <h5 class="text-second w-100">{{friend.firstname}} <b>{{friend.lastname}}</b></h5>
                                </div>
                                <div class="p-l-4" style="width: 100px; align-self: center">
                                    <button class="w-100 m-0 " @click="invitationReply(friend.id,true)">Akceptuj
                                    </button>
                                    <button class="w-100 m-0 m-t-1 button-outline-p"
                                            @click="invitationReply(friend.id,false)">Odrzuć
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <hr class="b-hr">
                        <span class="friendsCounter">Znajomych: {{friends.length}}</span>
                    </div>
                    <div v-if="friends.length == 0">
                        <h3 class="w-100 text-a-c m-b-5 m-t-4 text-third-d">Nie posiadasz jeszcze znajomych</h3>
                    </div>
                    <div v-else class="m-y-4">
                        <div class="card m-t-1" v-for="friend in friends">
                            <div class="card-body display-flex" style="position: relative;">
                                <div class="center-flex-a" style="height: auto;">
                                    <img class="circle-profile" :src="friend.profile_img" :alt="friend.firstname">
                                </div>
                                <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                    <h5 class="text-second w-100">{{friend.firstname}} <b>{{friend.lastname}}</b></h5>
                                    <small class="text-second-l w-100"><b>Rozpoczeliście znajomość:</b> {{friend.date}}
                                    </small>
                                </div>
                                <span class="deleteFriend" @click="promptForDeleteFriend(friend.id)"> <i
                                        class="i-cross"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-12">
                    <h4>Zaproś nowych znajomych</h4>
                    <p>Wpisz imię, nazwisko, email, a my przeszukamy naszą aplikację w poszukiwaniu Twojego znajomego.
                        Jeśli jest już u nas będziesz mógł go zaprosić do swoich znajomych.</p>
                    <form>
                        <div class="row-12 w-100">
                            <div class="col-8 col-sm-12 ">
                                <input type="text" id="friendSearchInput" v-model="searchUserData"
                                       placeholder="Wpisz imię, nazwisko lub email znajomego" autofocus required>
                            </div>
                            <div class="col-4 col-sm-12 ">
                                <button class="w-100 m-y-1" @click.stop.prevent="findFriends">Szukaj</button>
                            </div>
                        </div>
                    </form>

                    <div v-if="findedFriends.length == 0 && !searchFriendNow">
                        <h3 class="w-100 text-a-c m-b-5 m-t-4 text-third-d m-y-5 p-y-4">Wyszukaj znajomych używając
                            formlularza powyżej.</h3>
                    </div>
                    <div class="m-y-5 p-y-4" v-if="findedFriends.length == 0 && searchFriendNow">
                        <div class="searchLoader">
                            <div class="span">
                                <div class="help"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="m-y-4">
                        <div class="card m-t-1" v-for="friend in findedFriends">
                            <div class="card-body display-flex" style="position: relative;">
                                <div class="center-flex-a" style="height: auto;">
                                    <img class="circle-profile" :src="friend.profile_img" :alt="friend.firstname">
                                </div>
                                <div class="p-l-4" style="width: calc(100% - 175px); align-self: center">
                                    <h5 class="text-second w-100">{{friend.firstname}} <b>{{friend.lastname}}</b></h5>
                                </div>
                                <div class="p-l-4" style="width: 100px; align-self: center">
                                    <button @click="inviteFriend(friend.id)">Zaproś</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="display-flex" style="justify-content: center">
                        <small class="w-100 text-a-c"> Twój znajomy nie korzysta z naszej aplikacji? Możesz go
                            zaprosić.
                        </small>
                        <button class="button-md" @click="showModal('#inviteFriendsModal')">Zaproś znajomego do
                            aplikacji
                        </button>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal" id="inviteFriendsModal">
            <div class="modal-header">
                Wysyłanie zaproszenia do znajomego
            </div>
            <div class="modal-body" style="max-width: 600px">
                <p>Aby zaprosić znajomego do naszej aplikacji podaj jego adres email. Nie będzie on nigdzie
                    przechowywany, zostanie na niego jedynie wysłany email z zaproszeniem do korzystania z
                    aplikacji.</p>
                <label>Adres email znajomego</label>
                <input type="email" v-model="inviteEmail" placeholder="Adres email znajomego" required>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#inviteFriendsModal')">Anuluj</button>
                <button @click="inviteFriendsEmail">Wyślij zaproszenie</button>
            </div>
        </div>
        <div class="modal" id="confirmModal">
            <div class="modal-header">
                Usunięcie znajomego
            </div>
            <div class="modal-body" style="max-width: 600px">
                <p>Jesteś pewny, że chcesz usunąć tego znajomego? Wszytkie wasze powiązane dane zostaną usunięte, a
                    elementy pracy które udostępniłeś znajomemu nie będą już dla niego dostępne.</p>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#confirmModal')">Anuluj</button>
                <button @click="deleteFriend">Stanowcze usuń</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyFriends",
        data: function () {
            return {
                searchUserData: '',
                inviteEmail: '',
                friends: [],
                invite: [],
                findedFriends: [],
                deleteFriendId: 0,
                searchFriendNow: false
            }
        },
        methods: {
            inviteFriendsEmail() {
                try {
                    let valid = new Validator({
                        "adres email": this.inviteEmail,

                    });
                    valid.get("adres email").length(3, 255);

                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    if (!re.test(String(this.inviteEmail).toLowerCase())) {
                        notify.createNotifier("Niepoprawny adres email. Popraw go, aby wysłać wiadomość.", "danger", 4000);
                        throw "Błędny format adresu email";
                    }
                } catch (e) {
                    return false;
                }

                axios.post(`friends/emailInvite`, {
                    email: this.inviteEmail,
                })
                    .then((response) => {
                        window.notify.createNotifier("Zaproszenie zostało wysłane.", "success", 4000);
                        this.inviteEmail = '';
                        this.hideModal('#inviteFriendsModal');
                    })
            },
            promptForDeleteFriend(id) {
                this.deleteFriendId = id;
                this.showModal('#confirmModal');
            },
            deleteFriend() {
                axios.delete(`friends/${this.deleteFriendId}`)
                    .then((response) => {
                        window.notify.createNotifier("Osoba usunięta z Twoich znajomych", "success", 4000);
                        this.friends = this.friends.filter((friend) => {
                            return friend.id !== this.deleteFriendId;
                        });
                        this.deleteFriendId = 0;
                        this.hideModal('#confirmModal');
                    });
            },
            findFriends() {
                try {
                    let valid = new Validator({
                        "imie / nazwisko znajomego": this.searchUserData,
                    });
                    valid.get("imie / nazwisko znajomego").length(3, 255);
                } catch (e) {
                    return false;
                }

                if (this.searchUserData.indexOf(' ') >= 0) {
                    this.searchUserData = this.searchUserData.split(' ')[0];
                }

                this.searchFriendNow = true;
                axios.get(`friends/find?filter=firstname|LIKE|%${this.searchUserData}%,OR lastname|LIKE|%${this.searchUserData}%`)
                    .then((response) => {
                        this.findedFriends = response.data;
                        this.searchFriendNow = false;
                    }).catch(() => {
                        this.searchFriendNow = false;
                    })
            },
            inviteFriend(id) {
                axios.post(`friends/invite`, {id: id})
                    .then((response) => {
                        window.notify.createNotifier("Wysłano zaproszenie do znajomych. Oczekuj, aż osoba zaakceptuje Twoje zaproszenie.", "success", 6000);
                        this.findedFriends = this.findedFriends.filter((friend) => {
                            return friend.id !== id
                        });
                        this.searchUserData = '';
                    });
            },
            invitationReply(id, status) {
                axios.post(`friends/inviteReply`, {
                    id: id,
                    status: status
                })
                    .then((response) => {
                        if (status) {
                            this.friends = response.data;
                            window.notify.createNotifier("Jesteście od teraz znajomymi.", "success", 6000);
                        } else {
                            window.notify.createNotifier("Anulowano prośbę o znajomość.", "success", 6000);
                        }
                        this.invite = this.invite.filter((friend) => {
                            return friend.id !== id
                        });
                    });
            }
        },
        mounted: function () {
            axios.get(`friends`)
                .then((response) => {
                    this.friends = response.data.friends;
                    this.invite = response.data.invite;
                    this.friends.forEach((element) => {
                        element.date = moment(element.date_add).fromNow();
                    })
                });

            $(document).off('change', '#friendSearchInput');
            $(document).on('change', '#friendSearchInput', () => {
                this.findedFriends = [];
            });
        }
    }
</script>

<style lang="scss" scoped>

    .b-hr {
        border-width: 1px;
    }

    .friendsCounter {
        background-color: #3ba4e2;
        color: white;
        position: absolute;
        top: -12.5px;
        font-size: 12px;
        left: 50%;
        transform: translateX(-50%);
        line-height: 24px;
        text-align: center;
        min-width: 25px;
        height: 25px;
        padding: 0 10px;
        border-radius: 5px;
    }

    .deleteFriend {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        height: 12px;
        width: 12px;
        padding: 5px;
        background: #6e52a8;
        color: white;
        cursor: pointer;
        border-radius: 50%;
        transition: all .2s;

        &:hover {
            transform: rotate(90deg);
        }

        i {
            margin: 0;
        }
    }
</style>